import { render, staticRenderFns } from "./PriceItem.vue?vue&type=template&id=6981219a&scoped=true"
import script from "./PriceItem.vue?vue&type=script&lang=ts"
export * from "./PriceItem.vue?vue&type=script&lang=ts"
import style0 from "./PriceItem.vue?vue&type=style&index=0&id=6981219a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981219a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6981219a')) {
      api.createRecord('6981219a', component.options)
    } else {
      api.reload('6981219a', component.options)
    }
    module.hot.accept("./PriceItem.vue?vue&type=template&id=6981219a&scoped=true", function () {
      api.rerender('6981219a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/PriceItem.vue"
export default component.exports